import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../api/client";
import ScreenShareView from "../components/ScreenShareView";

/* Standalone screen-share page — opened in its own window/tab from the device
 * page so the remote session lives in a dedicated window (like a real remote-
 * control tool). Closing it ends the session. */
export default function ScreenSharePage() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const token = sp.get("token") || undefined;
  const deviceId = Number(id);
  const [hostname, setHostname] = useState<string>("device");

  useEffect(() => {
    document.title = "Screen share";
    api
      .get(`/api/v1/devices/${deviceId}`)
      .then((r) => {
        setHostname(r.data?.hostname || "device");
        document.title = `Screen share — ${r.data?.hostname || "device"}`;
      })
      .catch(() => {});
  }, [deviceId]);

  if (!deviceId) return null;
  return (
    <ScreenShareView
      deviceId={deviceId}
      hostname={hostname}
      token={token}
      onClose={() => window.close()}
    />
  );
}
